import { render } from "./AppTextarea.vue?vue&type=template&id=df516824"
import script from "./AppTextarea.vue?vue&type=script&lang=js"
export * from "./AppTextarea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/callum/Dev/saxton/saxton-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__